import { createSelector } from 'reselect';
import { RootState } from 'ReduxTypes';

export const selectOrder = (state: RootState) => state.order;

export const selectOrders = createSelector(
  selectOrder,
  (order) => order.orders,
);
